export const steps = {
  experience: {
    id: 1,
    label: 'Assessor Experience',
    intlKey: 'wizard.assessor_experience',
    completed: false,
    active: true,
    path: '/experience',
    next: '/details',
    allowedPaths: ['/experience', '/details', '/activity']
  },
  activity: {
    id: 2,
    label: 'Activity Details',
    intlKey: 'wizard.activity_details',
    completed: false,
    active: false,
    path: '/activity',
    next: '/details',
    allowedPaths: ['/welcome', '/details']
  },
  details: {
    id: 3,
    label: 'Personal details',
    intlKey: 'wizard.personal_details',
    completed: false,
    active: true,
    path: '/details',
    next: '/contact-details',
    allowedPaths: ['/contact-details', '/experience', '/activity']
  },
  contact: {
    id: 4,
    label: 'Contact details',
    intlKey: 'wizard.contact_details',
    completed: false,
    active: true,
    path: '/contact-details',
    next: '/account',
    allowedPaths: ['/details', '/account']
  },
  account: {
    id: 5,
    label: 'ORB Account',
    intlKey: 'wizard.orb_account',
    completed: false,
    active: true,
    path: '/account',
    next: '/success',
    allowedPaths: ['/contact-details', '/success']
  }
}

export const rootPath = '/register/assessor'

export const wizard = Object.keys(steps).map(item => {
  const currentStep = steps[item]

  let allowedPaths = currentStep.allowedPaths.concat(currentStep.next)

  allowedPaths = currentStep.allowedPaths.map(
    allowedPath => rootPath + allowedPath
  )

  return {
    id: currentStep.id,
    label: currentStep.label,
    completed: false,
    active: currentStep.active,
    intlKey: currentStep.intlKey,
    next: rootPath + currentStep.next,
    path: rootPath + currentStep.path,
    rootPath,
    allowedPaths
  }
})
